import React from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import './opening.css'; // Separate CSS file for styles




const Opening = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <div style={{
        backgroundImage: `linear-gradient(195deg, rgba(66, 66, 74, 0.6), rgba(25, 25, 25, 0.6)), url('bg.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '100vh',
      }}>
    <div className="landing-page" >
      <div className="content2">
        {/*<h1>
            TRAMS<br /> <span>Toolkit for</span>
        </h1>
        <p>
          Empowering Trusted, 
          <span>  Responsible AI Innovations.</span>
        </p>*/}
        <img src="TRAMS_LOGO_FINAL_FULL.png" alt="Logo" className='centered-image' />
        <div className="buttons">
            <Link to={'/SignIn'}>
              <button className="btn-primary">SIGN IN</button>
            </Link>
            <Link to={'/SignUp'}>
              <button className="btn-secondary">SIGN UP</button>
          </Link>  
        </div>
      </div>
    </div>
    <p className='copyright sign'>© Copyright, {year} Assentian. All Rights Reserved</p>
    <NavLink to="/PrivacyPolicy"  target="_blank" rel="noopener noreferrer">
      <p className='PrivPol'>Privacy Policy</p>
    </NavLink>
  </div>
  );
};

export default Opening;
